import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import loadDropboxChooser from '../utilities/loadDropboxChooser';

function DropboxChooserButton({ onFile, extensions = [], label = 'Choose from Dropbox', style = {} }) {
    const [loading, setLoading] = useState(false);

    // Warm the Chooser as soon as a button exists so it is ready by the time anyone
    // clicks. Mounting this button is the user action that justifies fetching the
    // third-party script — see utilities/loadDropboxChooser.js. A failure here is
    // silent; handleClick surfaces it if they actually click.
    useEffect(() => { loadDropboxChooser().catch(() => {}); }, []);

    const handleClick = async () => {
        let Dropbox;
        try {
            Dropbox = await loadDropboxChooser();
        } catch (err) {
            Swal.fire({ title: 'Error', text: err.message, icon: 'error', timer: 2000 });
            return;
        }
        Dropbox.choose({
            success: async (files) => {
                setLoading(true);
                try {
                    const res = await fetch(files[0].link);
                    if (!res.ok) throw new Error('Failed to download file from Dropbox');
                    const blob = await res.blob();
                    const file = new File([blob], files[0].name, { type: blob.type });
                    onFile(file);
                } catch (err) {
                    Swal.fire({ title: 'Error', text: err.message, icon: 'error', timer: 2000 });
                } finally {
                    setLoading(false);
                }
            },
            linkType: 'direct',
            multiselect: false,
            extensions: extensions.length > 0 ? extensions : undefined,
        });
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            disabled={loading}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                padding: '4px 12px',
                background: '#0061FF',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: loading ? 'wait' : 'pointer',
                fontSize: '13px',
                ...style,
            }}
        >
            <svg width="14" height="14" viewBox="0 0 40 40" fill="white">
                <path d="M12 2L2 8.5l10 6.5 10-6.5zM28 2l-10 6.5 10 6.5 10-6.5zM2 21.5L12 28l10-6.5-10-6.5zM28 15l-10 6.5 10 6.5 10-6.5zM12 29.5L22 36l10-6.5-10-6.5z"/>
            </svg>
            {loading ? 'Downloading…' : label}
        </button>
    );
}

export default DropboxChooserButton;